import { render, staticRenderFns } from "./OrderStatusText.vue?vue&type=template&id=2e12d96c&scoped=true"
import script from "./OrderStatusText.vue?vue&type=script&lang=js"
export * from "./OrderStatusText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e12d96c",
  null
  
)

export default component.exports